import { HttpStatusHandlers } from "../../../../../Common/HttpClient/IHttpClient";
import { UIUtil } from "../../Form/CustomizationContexts/HelperFunctionContext/UIUtil/UIUtil";
import { FormSettings } from "../../../Forms/Types/FormSettings";
import { CandyApiErrorResponse } from "../../../../../Common/CandyApiClient/ICandyApiClient";

export const getCandyApiHttpStatusHandlers = (theme: FormSettings["theme"]): HttpStatusHandlers => ({
    403: async (response: Response) => {
        const responseData: CandyApiErrorResponse = await response.json();
        if (responseData.errorCode === "InvalidEditSession") {
            const uiUtil = new UIUtil(theme);
            await uiUtil.sessionExpired();
        }
    },
});
